<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">

                <div class="col-12 mt-4 mb-4 gifted-voucher">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <img class="img-fluid" v-bind:src="'/img/' + this.logo"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                            </div>
                        </div>
                        <div class="card card-title text-center">
                            <h3>
                                Voucher Request Page
                            </h3>
                        </div>
                        <div class="row p-3">
                            <div class="col-md-12">
                                <div class="card mb-2">
                                    <div class="card-body">
                                        <p class="font-italic">Please fill out this form to request for your actual voucher code. Your voucher will be processed within 1-3 working days.</p>
                                        <p><i>Click Validate Button to validate Brand and Amount</i></p>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-body">
                                        <form id="voucherRequestForm">
                                            <div class="form-row">
                                                <div class="form-group col-md-5">
                                                    <label for="order_id">Gifted Order Number (Starts with 202xxx)</label>
                                                    <div class="input-group mb-3">
                                                        <input type="text" class="form-control" id="order_id" name="order_id" placeholder="Gifted Order Number" v-model="order_id">
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-secondary" @click="verify()" type="button">Validate</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group col-md-3">
                                                    <label for="mobile_number">Mobile Number</label>
                                                    <div class="input-group mb-3">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text" id="basic-addon1">09</span>
                                                    </div>
                                                    <input type="text" pattern="[0-9]+" maxlength="9" minlength="9" class="form-control"  id="mobile_number" name="mobile_number" >
                                                    </div>
                                                </div>

                                                <div class="form-group col-md-4">
                                                    <label for="mobile_number">Your Email Address</label>
                                                    <input type="email" class="form-control" id="email" name="email" />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label for="">Brand</label>
                                                    <input type="text" class="form-control" id="brand" name="brand" readonly />
                                                </div>
                                                <div class="form-group col-md-6">
                                                    <label for="">Amount</label>
                                                    <input type="text" class="form-control" id="amount" name="amount" readonly />
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="form-row">
                                                <div class="form-group col-md-12">
                                                    <input type="checkbox" id="agree" class="mr-2" /> All data is secure and will be processed according to Gifted.PH Data Privacy Standards. I have read the Privacy Policy.
                                                </div>
                                            </div>

                                            <input type="hidden" name="_token" id="token">
                                        </form>

                                        <div class="form-row">
                                            <div class="form-group col-md-12 text-center">
                                                <button type="button" @click="submitUser()" class="btn btn-success btn-lg" id="btn_submit" disabled>Send Request</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                 <div class="col-md-12">
                                    <h2>Gifted. The Gift Giving Company</h2>
                                    <p>For more information, visit <a target="_blank" href="https://gifted.ph/">www.gifted.ph</a> or email us at <a href="mailto:admin@gifted.ph">admin@gifted.ph</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import axios from 'axios'

    export default {
        props: [],
        data(){
            return {
                order_id: "",
                logo: "gifted-logo-voucher.jpg",
            }
        },
        mounted() {

        },
        methods: {
            submitUser: () => {

                if($("#agree").prop("checked")){
                    var order_id = $('#order_id').val();
                    var mobile_number = $('#mobile_number').val();
                    var brand = $('#brand').val();
                    var amount = $('#amount').val();

                    if(order_id == '' || mobile_number == '' || brand == '' || amount == '' ){
                        Swal.fire({
                            icon: 'error',
                            title: 'Please fill up all the fields.'
                        })
                    }
                    else{
                        if(mobile_number.length == 9){
                            var token = $('meta[name="csrf-token"]').attr('content');
                            $('#token').val(token);
                            var formData = $('#voucherRequestForm').serialize();
                            $.ajax({
                                type:'POST',
                                url:'/request/submit',
                                data: formData,
                                success: (result) => {
                                if(result)
                                {
                                    Swal.fire({
                                            icon: 'success',
                                            title: 'Thank you for your submission!',
                                            text: 'The voucher will be sent to your email or mobile number in 1 to 5 working days. Please email us at admin@gifted.ph for any inquiries. Thank you!',
                                            allowEscapeKey : false,
                                            allowOutsideClick: false,
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                window.location.reload();
                                            }
                                        })
                                }
                                },
                                beforeSend: () => {
                                    Swal.fire({
                                        title: 'Processing...',
                                        html: '<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                                        showConfirmButton: false,
                                        allowEscapeKey : false,
                                        allowOutsideClick: false,
                                    });
                                }
                            });
                        }
                        else{
                            if(mobile_number.length < 9)
                            {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Mobile Number cannot be less than 9 digits.'
                                })
                            }
                        }

                    }



                }
                else{
                    Swal.fire({
                        icon: 'info',
                        title: 'Did you read and agree the Privacy Policy?'
                    })
                }
            },
            verify: () => {
                var order_id = $('#order_id').val();
                var token = $('meta[name="csrf-token"]').attr('content');

                if(order_id)
                {

                    $.ajax({
                        type:'POST',
                        url:'request/verify',
                        data: {
                            _token: $('meta[name="csrf-token"]').attr('content'),
                            order_id: order_id,
                        },
                        dataType: 'JSON',
                        success: (result) => {
                            if(result.message == 'Invalid Order ID'){
                                 Swal.fire({
                                    icon: 'error',
                                    title: 'Invalid Order ID'
                                })
                                $('#order_id').val('')
                                $('#brand').val('')
                                $('#amount').val('')
                                 $('#btn_submit').prop("disabled", true);
                            }
                            else if(result.message == 'Invalid Merchant'){
                                 Swal.fire({
                                    icon: 'error',
                                    title: 'Your voucher has been sent to your email address and no need to fill out this request. For more information, please email admin@gifted.ph.'
                                })
                                $('#order_id').val('')
                                $('#brand').val('')
                                $('#amount').val('')
                                 $('#btn_submit').prop("disabled", true);
                            }
                            else if(result.message == 'redeemed'){
                                 Swal.fire({
                                    icon: 'error',
                                    title: 'Order ID is already Redeemed.'
                                })
                                $('#order_id').val('')
                                $('#brand').val('')
                                $('#amount').val('')
                                 $('#btn_submit').prop("disabled", true);
                            }
                            else if(result.message == 'used')
                            {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Order ID is already Submitted.'
                                })
                                $('#order_id').val('')
                                $('#brand').val('')
                                $('#amount').val('')
                                 $('#btn_submit').prop("disabled", true);
                            }
                            else{
                                $('#brand').val(result.brand)
                                $('#amount').val(result.amount)
                                $('#btn_submit').prop("disabled", false);
                                Swal.close();
                            }
                        },
                        beforeSend: () => {
                            Swal.fire({
                                title: 'Verifying...',
                                html: '<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                                showConfirmButton: false,
                                allowEscapeKey : false,
                                allowOutsideClick: false,
                            });
                        }
                    });
                }
                else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Order ID is required'
                    })
                }
            }
        }
    }



</script>
